angular.module('impactx.catalog').service('CompanyService', CompanyService);
CompanyService.$inject = ['dataGen', 'ToastService', 'BackService', 'ListHelperService'];

/**
 * Used to provide common functionality for company data.
 * @param dataGen data service dependency
 * @param ToastService for displaying messages
 * @param BackService for going back
 * @param ListHelperService service to handler list operations easier
 * @constructor
 */
function CompanyService(dataGen, ToastService, BackService, ListHelperService) {

    /**
     * Deletes company.
     * @param data data to process
     * @param isListDelete flag for delete in the list
     * @param listScope scope of the list
     * @param goBack flag to go back before showing toast
     */
    this.deleteCompany = function(data, isListDelete, listScope, goBack, entryPoint, listCtrl) {
        var requestObj = {},
            resultScope = {};
        if(data && data.id) {

            requestObj.ids = [data.id];

            dataGen.postAsForm(resultScope, requestObj, entryPoint).then(function(backendData) {

                if(goBack) {
                    BackService.back();
                }

                data.deleted = true;
                data.notDeprecated = false;
                data.canDelete = false;

                ToastService.openStandardToastAfterDeleteSuccess(resultScope, backendData);


                if(isListDelete) {
                    ListHelperService.refreshListData(listScope, listCtrl, {
                        unselectRow: data
                    });
                }
            });
        }
    };

    this.setCompanyListActions = function(ctrl, selectedListItems) {
        ctrl.getCompanyDataLink = function() {
            return "companydata/" + selectedListItems.getFirstSelectedId();
        };

        ctrl.getClientCompanyDataLink = function() {
            return "clientcompanydata/" + selectedListItems.getFirstSelectedId();
        };

        ctrl.getCompanyRelationDataLink = function() {
            return "companyrelation/" + selectedListItems.getFirstSelectedId();
        };

        ctrl.getCompanyInterfaceDataLink = function() {
            return "companyinterface/" + selectedListItems.getFirstSelectedId();
        };

        ctrl.isDeleted = function(data) {
            return (data && data.deleted);
        };

        ctrl.canDelete = function() {
            return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDelete &&
                !ctrl.isDeleted(selectedListItems.getFirstSelectedItem())
        };

    }
}